module.exports = __webpack_public_path__ + "static/media/28.06327967.jpg";